import { useSelector } from "react-redux";
import network from "../selectors/network";
import { getAgencySettings } from "../queries/agencySettings";
import { useQuery } from "react-query";

export function useMobileAppDownloadLinks(): {
  googleLink?: string | null;
  appleLink?: string | null;
  isLoading: boolean;
} {
  const networkHeaders = useSelector(network.defaultHeaders);

  const { data, isLoading } = useQuery("agencySettings", getAgencySettings(networkHeaders), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
  });

  return {
    googleLink: data?.googleDownloadLink,
    appleLink: data?.appleDownloadLink,
    isLoading,
  };
}
